import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Cliente } from "../model/cliente.model";
import { BaseApiService } from "src/app/services/base-api.service";
import { SessionStorageService } from "src/app/services/session-storage.service";

@Injectable({
  providedIn: "root",
})
export class FacecaptchaService extends BaseApiService {
  private CHALLENGE_ENDPOINT = "challenge";
  private APP_KEY_ENDPOINT = "appKey";
  private CAPTCHA_ENDPOINT = "captcha";
  private SEND_DOCUMENTS_ENDPOINT = "sendDocuments";
//
  constructor(
    private http: HttpClient,
    private localStorageService: SessionStorageService
  ) {
    super('oititec/oititec/', localStorageService);
  }

  // Gera credencial de acesso. Deve ser feita no backend
  public gerarAppKey(cliente: Cliente) {
    const url = `${this.baseUrl}${this.APP_KEY_ENDPOINT}`;

    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, cliente, { headers, observe: "response" });
  }


  public challenge(appKey: string) {
    const url = `${this.baseUrl}${this.CHALLENGE_ENDPOINT}`;

    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(
      url,
      { appkey: appKey },
      { headers, observe: "response" }
    );
  }

  // Envia imagens para o Certiface
  public captchaa(appkey: any, chkey: any, images: any) {
    const url = `${this.baseUrl}${this.CAPTCHA_ENDPOINT}`;

    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post(
      url,
      { appkey: appkey, chkey: chkey, images: images },
      { headers, observe: "response" }
    );
  }

  // Envia Documentos
  sendDocument(appkey: any, images: any) {

	const url = `${this.baseUrl}${this.SEND_DOCUMENTS_ENDPOINT}`;

	const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(
		url,
      {
        appkey: appkey,
        images: images,
      },
      { headers, observe: "response" }
    );
  }


}
